import * as lib from 'Root/lib/lib.js'
import axios from 'axios'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

export default {
    methods: {
        ajax(handler, payload, successCallback, errorCallback) {
            this.loading = true

            try {
                axios
                    .post(handler, payload)
                    .then((response) => {
                        const { hasError, errorMessages, data } = response.data

                        setTimeout(() => {
                            if (hasError) {
                                this.handleAjaxError(errorCallback, errorMessages)
                            } else {
                                this.hasError = false
                                this.loading = false

                                if (typeof successCallback === 'function') {
                                    successCallback(data)
                                }
                            }
                        }, 50)
                    })
                    .catch((error) => {
                        this.handleAjaxError(errorCallback)
                    })
            } catch (error) {
                this.handleAjaxError(errorCallback)
            }
        },

        handleAjaxError(errorCallback, errorMessages) {
            this.loading = false
            this.hasError = true

            const defaultServerErrorMsg =
                typeof this?.appData?.dictionary.defaultServerErrorMsg !== 'undefined'
                    ? this?.appData?.dictionary.defaultServerErrorMsg
                    : ''
            const msg = lib.hasValue(errorMessages) ? errorMessages : defaultServerErrorMsg
            const messageHtml = this.generateErrorMessagesHtml(msg)
            this.errorMessages = messageHtml

            if (typeof errorCallback === 'function') {
                errorCallback(messageHtml)
            }
        },

        generateErrorMessagesHtml(messages) {
            let msg = Array.isArray(messages) ? messages[0] : messages

            if (lib.hasValue(messages) && Array.isArray(messages)) {
                let msgList = '<ul>'
                messages.forEach((item) => {
                    msgList += `<li>${item}</li>`
                })
                msgList += '</ul>'
                msg = msgList
            }

            return msg
        },
    },
}
